import { Box, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { AddMainCategoryRequest } from "../../../models/productCategory.model";

const CategoryHeader = ({
  headerData,
}: {
  headerData: AddMainCategoryRequest;
}) => {
  return (
    <div>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          border: "1px solid #EDEFEF",
          borderRadius: "5px",
          backgroundColor: "#F6F8F9",
        }}
      >
        <Box sx={{ width: "100%", height: "80%", padding: "20px 20px" }}>
          <Grid
            container
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Grid
              item
              sx={{
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <Typography
                sx={{ fontSize: "1.1rem", color: "#1D4A87", fontWeight: "600" }}
              >
                {headerData?.logo === undefined || headerData?.logo === null ? (
                  <StorefrontIcon
                    style={{
                      width: "6vh",
                      height: "6vh",
                      borderRadius: "50%",
                      backgroundColor: "#fff",
                      border: "1px solid #C1C7CB",
                      padding: "10px",
                    }}
                  />
                ) : (
                  <img
                    src={`data:image/png;base64,${headerData?.logo}`}
                    style={{
                      width: "6vh",
                      height: "6vh",
                      borderRadius: "50%",
                      backgroundColor: "#fff",
                      border: "1px solid #C1C7CB",
                    }}
                  />
                )}
              </Typography>
              <Typography
                sx={{
                  fontSize: "1.1rem",
                  color: "#1D4A87",
                  fontWeight: "bold",
                }}
              >
                {headerData?.title}
                {"   "}
                {headerData?.englishTitle}
              </Typography>
              <Typography
                sx={{
                  fontSize: "1.1rem",
                  color: "#1D4A87",
                  fontWeight: "600",
                  marginRight: "-1vh",
                }}
              >
                {headerData?.isActive}
                {headerData?.isActive === true ? (
                  <b style={{ color: "#28A745" }}>(فعال)</b>
                ) : (
                  <b style={{ color: "#E6123D" }}>(غیر فعال)</b>
                )}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </div>
  );
};

export default CategoryHeader;
